var map = {
	"./elephant_ui_disappointed": 1520,
	"./elephant_ui_disappointed.svg": 1520,
	"./elephant_ui_working": 1403,
	"./elephant_ui_working.svg": 1403,
	"./glitch-preview": 1521,
	"./glitch-preview.jpg": 1521,
	"./logo_warn_glitch": 1065,
	"./logo_warn_glitch.svg": 1065,
	"./mbstobon-ui-0": 1522,
	"./mbstobon-ui-0.png": 1522,
	"./mbstobon-ui-1": 1523,
	"./mbstobon-ui-1.png": 1523,
	"./mbstobon-ui-2": 1524,
	"./mbstobon-ui-2.png": 1524,
	"./mbstobon-ui-3": 1525,
	"./mbstobon-ui-3.png": 1525,
	"./wave-drawer": 1526,
	"./wave-drawer-glitched": 1527,
	"./wave-drawer-glitched.png": 1527,
	"./wave-drawer.png": 1526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1680;